import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Grid from '../Base/AntGrid';
import { fetchServer } from '../Base/modelManager';
import { message } from 'antd';
import moment from 'moment';
import { excelExport } from '../Base/ExportExcelAction';
import { Button, Form, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import BadgeEditor from './BadgeEditor'
import {  FilterDropDown } from '../Base/Filters';
import FilterEnum from '../Base/FilterEnum';

class Badges extends React.Component {
    constructor(props) {
        super(props)

        const actions = [
            {
                id: 'reload',
                icon: <img src="/assets/images/icons/picto_rafraichir.svg" alt="Bootstrap" width="20" height="20" className='gridHeaderImage'/>,
                tooltip: 'Recharger',
                onExecute: () => {
                    this.handleFetch()
                }
            },
            excelExport(this.props.apiUrl + '/Services/exportBadge', 'Badge.xlsx', this.getFilterProcessed, () => '', this.getToken)
        ]


        this.state = {
            data: [],
            columns: [],
            loading: false,
            keyField: 'uid',
            queryColumns: [],
            height: 0,
            quickFilterString: '',
            actions: actions,
            render: true,
            selectedRows: [],
            modal: {
                isOpen: false,
                view: null,
                record: null,

            },
            filters: {
                "badge": null,
                "typebadge": null,
                "status": [500]
              },
            pagination: {
                current: 1,
                total: 0,
                pageSize: 10,
            }
        }
    }

    getToken = () => {
        return this.props.JWTToken
    }

    componentDidMount() {
        this.handleFetch()
    }


    componentDidUpdate(prevProp) {
        if (prevProp.currentClient !== this.props.currentClient)
            this.handleFetch()
    }

    closeModal = () => {
        this.setState({
            modal: {
                isOpen: false,
                view: null,
                record: null
            }
        })
        this.handleFetch()
    }

    getModalComponent = () => {
        const { modal } = this.state

        if (modal.isOpen) {
            return (
                <Modal show={modal.isOpen} >
                    <BadgeEditor record={modal.record} onClose={() => this.closeModal()} actions={this.state.actions} />

                </Modal>
            )
        }
    }

    getFilterProcessed = () => {
        const { filter } = this.state

        return this.processFilter(filter)
    }


    columns = () => {
        const cols = []



        cols.push(
            {
                title: 'Numéro',
                render: (text,record) => record.badge,
                key: 'badge',
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <FilterDropDown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    >
                        <Form.Control
                            
                            placeholder='numéro de badge contient'
                            value={selectedKeys}
                            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                            onPressEnter={() => confirm()}
                            style={{ marginBottom: 8, display: 'block' }}
                        />
                    </FilterDropDown>
                ),
                
            },
            {
                title: 'Type',
                key: 'typebadge',
                render: (text,record) => record.typebadge ? record.typebadge.libelle : '',
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <FilterDropDown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    >
                        <FilterEnum
                            datasource='/AbonnementBadge'
                            selected={selectedKeys}
                            onChange={(value) => { setSelectedKeys([...value]) }}
                            style={{ marginBottom: 8, display: 'block' }}
                            id='code'
                            libelle='libelle'
                        /><br />
                    </FilterDropDown>
                ),
                
            },
           
            {
                title: 'Statut',
                render: (text,record) => record.status.libelle,
                key: 'status',
                defaultFilteredValue:[500,600],
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <FilterDropDown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    >
                        <FilterEnum
                            datasource='/statusBadge'
                            selected={selectedKeys}
                            onChange={(value) => { setSelectedKeys([...value]) }}
                            style={{ marginBottom: 8, display: 'block' }}
                            id='uid'
                            libelle='libelle'
                        /><br />
                    </FilterDropDown>
                ),
            },
            {
                title: 'Date Statut',
                render: (text,record) => record.datestatus !== null ? moment(record.datestatus).format('DD/MM/YYYY') : '',
                key: 'datestatus',
              
                
                
            },

            {
                title: 'Centre de Cout',
                render: (text,record) => record.costcenter,
                key: 'datecreation'
            },
            {

                title: 'Titulaire',
                render: (text,record) => record.titulaire,
            },
        )



/*
        const actionsWidth = (3 * 30)
        cols.push({
            title: 'Actions',
            key: 'operation',
            dataIndex: 'operation',
            fixed: 'right',
            width: actionsWidth,
            render: (text,record) => this.actionRenderer(record),
        });

*/
        return cols
    }




    render() {

        return (
            <>
                {this.getModalComponent()}
                <Grid
                    data={this.state.data}
                    columns={this.columns()}
                    pagination={this.state.pagination}
                    loading={this.state.loading}
                    keyField='uid'
                    handleFetch={this.handleFetch}
                    actions={this.state.actions}
                    title="- MES BADGES -"
                />
            </>
        )


    }

    processFilter = (filter) => {


        let filterStr = ''

        if (filter !== undefined && filter !== null) {
            const filtersValue = Object.keys(filter);
            if (filtersValue.length > 0) {
                filtersValue.forEach(key => {
                    if (key === 'badge' && filter[key] !== null) {
                        if (filterStr !== '') filterStr = filterStr + ' and '
                        filterStr = filterStr + 'contains(badge,\'' + filter[key] + '\')'
                    }
                    if (key === 'client' && filter[key] !== null) {
                        if (filterStr !== '') filterStr = filterStr + ' and '
                        filterStr = filterStr + '(contains(client/numero,\'' + filter[key] + '\') or contains(client/nom,\'' + filter[key] + '\'))'
                    }
                    if (key === 'actif')
                        if (filter[key] !== null && filter[key][0] !== -1) {
                            if (filterStr !== '') filterStr = filterStr + ' and '
                            filterStr = filterStr + ' status/isActif eq ' + (filter[key][0] === 1 ? 'true' : 'false')
                        }
                    if (key === 'status' && filter[key] !== null && filter[key].length > 0) {
                        let str = ''
                        filter[key].forEach((value, index) => {
                            if (index > 0) str = str + ' or '
                            str = str + 'status/uid eq ' + value
                        })
                        if (filterStr !== '') filterStr = filterStr + ' and '
                        filterStr = filterStr + '(' + str + ')'
                    }
                    if (key === 'fournisseur' && filter[key] !== null && filter[key].length > 0) {
                        let str = ''
                        filter[key].forEach((value, index) => {
                            if (index > 0) str = str + ' or '
                            str = str + 'fournisseur/code eq \'' + value + '\''
                        })
                        if (filterStr !== '') filterStr = filterStr + ' and '
                        filterStr = filterStr + '(' + str + ')'
                    }
                    if (key === 'typebadge' && filter[key] !== null && filter[key].length > 0) {
                        let str = ''
                        filter[key].forEach((value, index) => {
                            if (index > 0) str = str + ' or '
                            str = str + 'typebadge/code eq \'' + value + '\''
                        })
                        if (filterStr !== '') filterStr = filterStr + ' and '
                        filterStr = filterStr + '(' + str + ')'
                    }
                })
            }


        }


        if (this.props.client !== undefined) {
            if (filterStr !== '') filterStr = filterStr + ' and '

            filterStr = filterStr + ' client/uid eq ' + this.props.client.uid
        }





        if (filterStr !== '')
            filterStr = '&$filter=' + filterStr




        return filterStr
    }

    onError = (error) => {
        message.error(error)
    }

    openModal = (action, data) => {
        this.setState(
            {
                modal: {
                    isOpen: true,
                    view: action,
                    record: data,
                }
            }
        )
    }

    actionRenderer = (record) => {


        const actions = []
        actions.push(
            {
                id: 'edit',
                icon: <img className="gridHeaderImage" alt='' src="/assets/images/icons/pencil-square.svg" style={{ 'marginRight': '4px' }} />,
                tooltip: 'Modifier',
                onExecute: (event) => {
                    this.openModal('Edit', record)
                }
            })



        return (
            <span>
                {
                    actions.map((action) => {

                        const renderTooltip = (props) =>
                            <Tooltip id={props.id}>
                                {props.tooltip}
                            </Tooltip>

                        return (
                            <OverlayTrigger
                                key={action.id}
                                placement="right"
                                delay={{ show: 250, hide: 400 }}
                                overlay={renderTooltip(action)}
                            >

                                <Button bsPrefix="gridButton" onClick={(event) => { action.onExecute(event) }}> {action.icon}</Button>

                            </OverlayTrigger>

                        )

                    })
                }
            </span>

        )
    }

    handleFetch = (pagination, filters, sorter) => {



        if (this.state.loading === false) {
            this.setState({ loading: true })

            if (pagination === undefined)
                pagination = this.state.pagination


            if (filters === undefined)
                filters = this.state.filters

            if (sorter === undefined)
                sorter = this.state.sorter


            const filter = this.processFilter(filters)

            // filter.page = page;
            // filter.pageSize = this.state.pageSize

            const request = {
                endPoint: this.props.apiUrl + '/badge?$expand=typeBadge,status,fournisseur&$top=' + pagination.pageSize + '&$skip=' + pagination.pageSize * (pagination.current - 1) + '&$inlinecount=allpages' + filter,
                method: 'GET',
                token: this.props.JWTToken
            }

            fetchServer(request, (json) => {
                this.setState(({
                    loading: false,
                    data: json.value,
                    pagination: {
                        total: json['@xdata.count'],
                        current: pagination.current,
                        pageSize: pagination.pageSize
                    },
                    render: true,
                    filters: filters

                }))
            }, this.onError)

        }
    }
}


const mapStateToProps = (state) => {
    return ({
        serverConfigLoaded: state.server.initialized,
        clients: state.authentication.clients,
        currentClient: state.authentication.currentClient,
        JWTToken: state.authentication.JWTToken,
        apiUrl: state.server.apiUrl,
    })
}

Badges.propTypes = {
    dispatch: PropTypes.func,
    apiUrl: PropTypes.string,
    clients: PropTypes.array,
    currentClient: PropTypes.object,
    JWTToken: PropTypes.string
};

export default connect(mapStateToProps)(Badges);
